<!-- ======= About Section ======= -->
<section id="about" class="about">
  <div class="container" data-aos="fade-up">
    <div class="section-title">
      <h2>Sobre mí</h2>
      <p>
        {{titular.sobremi}}
      </p>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <img [src]="titular.img" class="img-fluid" alt="" />
      </div>
      <div class="col-lg-8 pt-4 pt-lg-0 content">
        <h3>Desarrollador de Software BackEnd &amp; FrontEnd</h3>
        <div class="row p-4">
          <div class="col-lg-6">
            <ul>
              <li>
                <i class="bi bi-chevron-right"></i> <strong>Cumpleaños:</strong>
                <span>{{ titular.cumpleanios }}</span>
              </li>
              <li>
                <i class="bi bi-chevron-right"></i> <strong>Profesión:</strong>
                <span>{{  titular.profesion }}</span>
              </li>
              <li>
                <i class="bi bi-chevron-right"></i> <strong>Celular:</strong>
                <span>{{ titular.celular }}</span>
              </li>
              <li>
                <i class="bi bi-chevron-right"></i> <strong>Ciudad:</strong>
                <span>{{ titular.ciudad }}</span>
              </li>
            </ul>
          </div>
          <div class="col-lg-6">
            <ul>
              <li>
                <i class="bi bi-chevron-right"></i> <strong>Edad:</strong>
                <span>{{ titular.edad }}</span>
              </li>
              <li>
                <i class="bi bi-chevron-right"></i> <strong>Grado:</strong>
                <span>{{ titular.grado }}</span>
              </li>
              <li>
                <i class="bi bi-chevron-right"></i>
                <strong>Email:</strong> <span>{{ titular.email }}</span>
              </li>
              <li>
                <i class="bi bi-chevron-right"></i> <strong>Freelance:</strong>
                <span>{{ titular.freelance}}</span>
              </li>
            </ul>
          </div>
        </div>
        <p>
          {{titular.sobremi2}}
        </p>
      </div>
    </div>
  </div>
</section>
<!-- End About Section -->
